export enum RequestStatusEnum {
  ComplaintInDraft = 1,
  PendingCentralQaAcknowledgement = 2,
  ActionAssignmentPendingWithInvestigator = 3,
  TasksWipWithTaskOwner = 4,
  CorrectiveActionAssignmentPendingWithQa = 5,
  CorrectiveActionsWipWithOwner = 6,
  AllCorrectiveActionsClosed = 7,
  CustomerRatingPending = 8,
  CustomerRatingsUnderReview = 9,
  ComplaintClosed = 10,
}
